import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { PostProductsDrawer } from '../../ui/posts/PostProductsDrawer';
import { analyticsService } from '../../utils/analyticsService';
import { trackEcommerceEvent } from '../../utils/ecommerce';
import {
    getPageNameByEventSource,
    ymTrackMoreProductsClickOut,
    ymTrackProductClickOut,
    ymTrackProductsCatalogClick,
} from '../../utils/metrika';
import { useBackButton } from '../../utils/useBackButton';
import { DEFAULT_CLOSE_ANIMATION_DELAY } from '../constants';
import { useCurrentUser } from '../users/useCurrentUser';

export const PostProductsDialog = () => {
    const { state } = useLocation();
    const { post, eventSource } = state;
    const { products, business } = post;
    const onNavigateBack = useBackButton();
    const currentUser = useCurrentUser();

    const closeDialog = useCallback(() => {
        setTimeout(onNavigateBack, DEFAULT_CLOSE_ANIMATION_DELAY);
    }, [onNavigateBack]);

    const trackProductClickOut = useCallback(
        (props: { url?: string; target: string; productId?: string }) => {
            analyticsService.trackClickOut({
                postId: post.id,
                djRequestId: post.djRequestId,
                logContext: post.logContext,
                isBoosted: Boolean(post.adsData),
                clickoutUrl: props.url,
                eventSource,
                productId: props.productId,
                target: props.target,
                businessId: business?.id,
            });
            props.target === 'product'
                ? ymTrackProductClickOut({
                      page: getPageNameByEventSource(eventSource),
                      userLogin: currentUser?.login,
                  })
                : ymTrackMoreProductsClickOut({
                      page: getPageNameByEventSource(eventSource),
                      userLogin: currentUser?.login,
                  });
            trackEcommerceEvent({
                post,
                trackEcommerceView: true,
                trackEcommerceAdd: true,
            });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [products, business, currentUser?.login, eventSource],
    );

    const onCatalogClick = useCallback(() => {
        analyticsService.trackOpenCatalog({
            postId: post.id,
            eventSource: eventSource,
            djRequestId: post.djRequestId,
            logContext: post.logContext,
        });
        ymTrackProductsCatalogClick({
            page: getPageNameByEventSource(eventSource),
            userLogin: currentUser?.login,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [post.id, post.djRequestId, eventSource, currentUser?.login]);

    return (
        <PostProductsDrawer
            trackProductClickOut={trackProductClickOut}
            onCatalogClick={onCatalogClick}
            products={products}
            business={business}
            handleClose={closeDialog}
        />
    );
};
